export default [() => {
    let addPossessive = (string) => {
        if (string.substr(-1, 1) === 's') {
            string += "'";
            return string;
        }

        string += "'s";

        return string;
    };

    let addSuffix = (string, suffix, pluralCount, suffixPlural) => {
        string += ` ${suffix}`;
        if (pluralCount > 1 && string.substr(-1, 1) !== 's') {
            string += suffixPlural;
        }

        return string;
    };

    return {
        format: (guest, possessive = false, suffix = '', pluralCount = 0, suffixPlural = 's') => {
            let formatted = (`${guest.title || ''} ${guest.first_name || ''} ${guest.last_name || ''}`).trim();

            if (possessive) {
                formatted = addPossessive(formatted);
            }
            if (suffix) {
                formatted = addSuffix(formatted, suffix, pluralCount, suffixPlural);
            }

            return formatted;
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/guest/services/guest.name.service.js